import { AlertCircle, type LucideIcon } from 'lucide-react'

/** Full-viewport centered error/empty state with an icon + optional title. */
export function FullScreenError({
  title,
  icon: Icon = AlertCircle,
}: {
  title?: string
  icon?: LucideIcon
}) {
  return (
    <div className="h-dvh bg-background flex items-center justify-center px-4 md:px-0">
      <div className="text-center">
        <Icon className="h-12 w-12 text-destructive mx-auto mb-4" />
        {title && <h2 className="text-xl font-semibold text-foreground mb-2">{title}</h2>}
      </div>
    </div>
  )
}
